import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DotLoadingComponent } from './dot-loading.component';

@NgModule({
  imports: [CommonModule],
  declarations: [DotLoadingComponent],
  exports: [DotLoadingComponent],
})
export class DotLoadingModule {}
